module.exports = __webpack_public_path__ + "static/Planet7-Casino-8f88fbc40a05156105f7112720cb26a0.webp";